import type { ProductCardLayout, ProductCardProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { ColorField, NumberField, SelectField, TextField } from "./fields.js";
import { MediaField } from "./MediaField.js";
import type { WidgetInspectorProps } from "./registry.js";

const LAYOUT = ["vertical", "horizontal"] as const;

export function ProductCardInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as ProductCardProps;

  return (
    <>
      <SelectField
        label="Layout"
        value={p.layout ?? "vertical"}
        options={LAYOUT}
        onChange={(v) => update(widget.id, { layout: v as ProductCardLayout })}
      />
      <MediaField
        label="Image URL"
        value={p.imageUrl}
        onChange={(v) => update(widget.id, { imageUrl: v })}
      />
      <TextField
        label="Image alt"
        value={p.imageAlt ?? ""}
        onChange={(v) => update(widget.id, { imageAlt: v || undefined })}
      />
      <TextField
        label="Title"
        value={p.title}
        onChange={(v) => update(widget.id, { title: v })}
      />
      <TextField
        label="Description"
        value={p.description ?? ""}
        multiline
        onChange={(v) => update(widget.id, { description: v || undefined })}
      />
      <div className="emke-inspector-grid-2" style={{ padding: "0 16px" }}>
        <TextField
          label="Price"
          value={p.price}
          onChange={(v) => update(widget.id, { price: v })}
        />
        <TextField
          label="Compare at"
          value={p.compareAtPrice ?? ""}
          onChange={(v) => update(widget.id, { compareAtPrice: v || undefined })}
        />
      </div>
      <div className="emke-inspector-grid-2" style={{ padding: "0 16px" }}>
        <TextField
          label="Badge"
          value={p.badge ?? ""}
          onChange={(v) => update(widget.id, { badge: v || undefined })}
        />
        <ColorField
          label="Badge colour"
          value={p.badgeColor ?? "#ef4444"}
          onChange={(v) => update(widget.id, { badgeColor: v })}
        />
      </div>
      <div className="emke-inspector-grid-2" style={{ padding: "0 16px" }}>
        <TextField
          label="CTA label"
          value={p.ctaLabel}
          onChange={(v) => update(widget.id, { ctaLabel: v })}
        />
        <TextField
          label="CTA URL"
          value={p.ctaHref}
          onChange={(v) => update(widget.id, { ctaHref: v })}
        />
      </div>
      <ColorField
        label="Background"
        value={p.background ?? "#ffffff"}
        onChange={(v) => update(widget.id, { background: v })}
      />
      <ColorField
        label="Text"
        value={p.textColor ?? "#0f172a"}
        onChange={(v) => update(widget.id, { textColor: v })}
      />
      <ColorField
        label="Accent (CTA)"
        value={p.accent ?? "#111827"}
        onChange={(v) => update(widget.id, { accent: v })}
      />
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 12}
        min={0}
        max={32}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
